import {cn} from '@/utils';

function Skeleton({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn('animate-pulse rounded-sm bg-gray-200', className)}
			{...props}
		/>
	);
}

export {Skeleton};
